import React, { useState } from "react";
import { useNavigate } from "react-router";

function LoanRequest() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    loan_amount: null,
    repayment_source: "",
    purpose_description: "",
    term_condition: 0,
    loan_term: "",
    business_name: "",
    business_type: "",
    business_registration_number: null,
    business_address: "",
    business_email: "",
    business_phone: 0,
    business_transaction_value: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    home_address: "",
    date_of_birth: "",
    bvn: "",
    nin: "",
    email: "",
    phoneno: "",
    government_idcard: null,
    proof_of_address: null,
    business_certificate: null,
    operating_lincense: null,
    photograph: null,
    facial_verification: null,
    exterior_view: null,
    interior_view: null,
    terminal_setup: null,
    action_view: null,
  });

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));

    console.log(formData);
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent page reload
    console.log("Submitted data:", formData);
    navigate("kyc");
    sessionStorage.setItem("form", JSON.stringify(formData));
    sessionStorage.setItem("isAccepted", JSON.stringify(true));
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white p-5 rounded-lg shadow-md w-2/3 mx-auto"
    >
      <h2 className="text-xl font-semibold mb-4">Loan Request</h2>
      <div className="flex flex-col lg:grid lg:grid-cols-2 lg:grid-rows-2 gap-4">
        <div>
          <label className="block ">Loan amount</label>
          <input
            type="number"
            name="loan_amount"
            value={formData.loan_amount}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder="N 340,000"
            required
          />
        </div>
        <div>
          <label className="block ">Expected repayment source</label>
          <select
            name="repayment_source"
            value={formData.repayment_source}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded mt-1"
          >
            Daily pos sales
            <option value="">Select</option>
            <option value="Daily POS sales">Daily POS sales</option>
            <option value="Weekly savings contribution">
              Weekly savings contribution
            </option>
            <option value="Bank transfer from personal or business account">
              Bank transfer from personal or business account
            </option>
            <option value="Income from other business activities">
              Income from other business activities
            </option>
            <option value="Third party sponsor or guarantor">
              Third party sponsor or guarantor
            </option>
          </select>
        </div>

        <div>
          <label className="block">Loan repayment amount</label>
          <input
            type="number"
            name="repayment_amount"
            value={formData.repayment_amount || ""}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder="N 370,000"
          />
        </div>

        <div>
          <label className="block ">Repayment duration</label>
          <select
            name="loan_term"
            value={formData.loan_term}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded mt-1"
          >
            <option value="">Select duration</option>
            <option value="4 Months">4 Months</option>
            <option value="6 Months">6 Months</option>
            <option value="8 Months">8 Months</option>
            <option value="10 Months">10 Months</option>
            <option value="12 Months">12 Months</option>
          </select>
        </div>
      </div>
      <div>
        <label className="block mt-4">Loan purpose description</label>
        <textarea
          type="text"
          name="purpose_description"
          value={formData.purpose_description}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded mt-1"
          placeholder="Restocking rice, canned goods and drinks"
        />
      </div>

      <div className="flex items-center mt-4 ">
        <input
          type="checkbox"
          name="term_condition"
          checked={formData.term_condition}
          onChange={handleChange}
          id="terms"
          className="mr-2"
          required
        />
        <label htmlFor="terms" className="text-sm">
          I agree to the{" "}
          <span className="text-blue-500 underline">Terms & Conditions</span> of
          this loan request
        </label>
      </div>

      <button
        className="w-full py-2 bg-gray-500 text-white rounded hover:bg-gray-700 mt-4"
        type="submit"
      >
        Request a loan
      </button>
    </form>
  );
}

export default LoanRequest;
